import React from 'react';
const facts = [{
  value: '90',
  label: 'Activities, each in three versions'
}, {
  value: '270',
  label: 'Ready-to-run versions'
}, {
  value: '48',
  label: 'Planning worksheets'
}, {
  value: '15/30/45',
  label: 'Minute sessions, plus a 10-min 1:1 visit'
}];
export function SocialProofBar() {
  return <section className="w-full bg-plum-deep" data-id="element-261" data-mp="25tn8pt9grgsi">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-262" data-mp="25qrae3tpeq3j">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-plum-line bg-plum-line sm:grid-cols-4" data-id="element-263" data-mp="32i1s6dm2jokm">
          {facts.map(fact => <div key={fact.label} className="bg-plum px-4 py-5 text-center" data-id="element-264" data-mp="2ti6fu5gs1nj0">
              <div className="font-display font-bold text-3xl sm:text-4xl leading-none text-gold" data-id="element-265" data-mp="2tk9h5lndr331">
                {fact.value}
              </div>
              <div className="mt-2 text-[10px] font-semibold uppercase tracking-widest text-white/65" data-id="element-266" data-mp="1i4ayqr6bb4p5">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}